import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import WhatsAppFAB from "@/components/WhatsAppFAB";
import { BRAND, FAQS } from "@/lib/brand";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { MessageCircle, Phone, ArrowRight } from "lucide-react";

export default function FAQPage() {
  useEffect(() => { document.title = `FAQ — ${BRAND.name}`; }, []);

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <SiteHeader />

      <section className="max-w-[980px] mx-auto px-5 md:px-8 py-16">
        <div className="max-w-3xl">
          <div className="eyebrow">FAQ</div>
          <h1 className="font-heading font-bold text-4xl md:text-6xl mt-4 leading-[1.05]">
            Questions, answered <span className="text-brand-gradient">honestly.</span>
          </h1>
          <p className="mt-5 text-slate-600 text-lg leading-relaxed">
            Don't see your question? Send us a WhatsApp message or call us during working hours.
          </p>
        </div>

        <div className="mt-10">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-page-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                data-testid={`faq-page-item-${i}`}
                className="border border-slate-200 rounded-2xl mb-3 px-5 bg-white"
              >
                <AccordionTrigger className="text-left font-heading font-semibold text-[16px] hover:no-underline py-4">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed text-[15px] pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        <div className="mt-12 rounded-[24px] bg-gradient-to-br from-[#0A2540] to-[#0F9D58] p-10 text-white">
          <h3 className="font-heading font-bold text-2xl md:text-3xl">Still have a question?</h3>
          <p className="mt-2 text-slate-200 max-w-xl">A senior advisor will personally respond within 24 working hours.</p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link to="/contact" data-testid="faq-cta-contact" className="btn-gold text-sm">
              Book a free review <ArrowRight className="w-4 h-4" />
            </Link>
            <a href={BRAND.whatsappUrl} target="_blank" rel="noreferrer" data-testid="faq-cta-whatsapp" className="btn-emerald text-sm">
              <MessageCircle className="w-4 h-4" /> WhatsApp
            </a>
            <a href={BRAND.telUrl} data-testid="faq-cta-call" className="px-5 py-3 rounded-full border border-white/30 text-white hover:bg-white/10 text-sm font-semibold inline-flex items-center gap-2">
              <Phone className="w-4 h-4" /> {BRAND.phoneIntl}
            </a>
          </div>
        </div>
      </section>

      <SiteFooter />
      <WhatsAppFAB />
    </div>
  );
}
